import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "./Button";

export function SessionRodSetups({
  sessionId,
}: {
  sessionId: number | string;
  anglers?: any[];
  targetSpecies?: string;
  lakeId?: number | string;
  sessionStartAt?: string;
  catches?: any[];
}) {
  const sessionQuery = useQuery({
    queryKey: ["carpintel_session", String(sessionId)],
    queryFn: () =>
      fetch(`/app-api/sessions/${sessionId}`).then((response) =>
        response.ok ? response.json() : null,
      ),
  });

  if (!sessionQuery.data || sessionQuery.data.end_at) return null;

  return (
    <section className="rounded-xl border border-accent/30 bg-accent/5 p-4">
      <div className="flex items-start gap-3">
        <SlidersHorizontal className="mt-0.5 size-5 shrink-0 text-accent" />
        <div className="min-w-0 flex-1">
          <h2 className="font-semibold text-primary">Live rod controls</h2>
          <p className="mt-1 text-sm leading-6 text-secondary">
            Rod tackle is managed on the live board so Position, Lead, Rig,
            Hookbait and Feed can change independently without resetting each
            other's exposure time.
          </p>
          <Button asChild className="mt-3">
            <Link to={`/live/${sessionId}`}>Open live rod board</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
